import { useCallback, useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";
import { useSync } from "@/lib/live";
import { useDetail } from "@/admin/AdminDetail";
import { ContactButtons } from "@/admin/ui";

export const DispatchAttention = () => {
  const [rows, setRows] = useState([]);
  const open = useDetail();
  const load = useCallback(() => api.get("/admin/attention").then((r) => setRows(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  useSync(load);
  if (!rows.length) return null;
  return (
    <section className="space-y-2 rounded-2xl border-2 border-[#E05C3A] bg-[#FDF1EC] p-4" data-testid="dispatch-attention">
      <p className="flex items-center gap-2 font-bold text-[#B4401F]"><AlertTriangle className="h-5 w-5" />Handle first: {rows.length} overdue or missed pickup{rows.length > 1 ? "s" : ""}</p>
      {rows.map((b) => (
        <div key={b.booking_id} className="flex flex-wrap items-center justify-between gap-3 rounded-xl bg-white p-3 text-sm" data-testid={`attention-${b.booking_id}`}>
          <div>
            <span className={`mr-2 rounded-full px-2 py-0.5 text-[10px] font-bold text-white ${b.kind === "missed" ? "bg-[#B4401F]" : "bg-[#E05C3A]"}`}>{b.kind === "missed" ? "Partner couldn't complete" : "Overdue"}</span>
            <button onClick={() => open({ type: "customer", id: b.user_id, title: b.customer })} className="font-bold text-[#0D3B2B] underline">{b.booking_id} · {b.customer}</button>
            <p className="text-xs text-[#4A6358]">{b.date} · {b.slot_label} · {b.staff ? `with ${b.staff}${b.trip_status ? ` (${b.trip_status})` : ""}` : "no partner"}
              {b.missed && b.kind === "missed" && ` · ${b.missed.staff_name}: ${b.missed.reason}${b.missed.note ? ` (${b.missed.note})` : ""} · waiting for customer's choice`}</p>
          </div>
          <ContactButtons mobile={b.mobile} testid={`attention-${b.booking_id}`} />
        </div>
      ))}
    </section>
  );
};
